import React from 'react';
import './DeviceNotificationSettingsModal.css';

const DeviceNotificationSettingsModal = ({ open, onClose, notificationSettings, onToggle }) => {
  if (!open) return null;
  
  return (
    <div className="device-modal-overlay">
      <div className="device-modal">
        <div className="device-modal-header">
          <span className="device-modal-title">Device Notification Settings</span>
          <span className="device-modal-close" onClick={onClose}>&times;</span>
        </div>
        <div className="device-modal-list">
          {notificationSettings.map((setting, idx) => (
            <div className="device-modal-list-item" key={idx}>
              <span>{setting?.notificationType?.name}</span>
              <span className={`device-modal-switch${setting.userNotificationSetting?.status === "ON" ? ' device-modal-switch-on' : ' device-modal-switch-off'}`}
                onClick={() => onToggle(idx)}>
                <span className="device-modal-switch-label">{setting.userNotificationSetting?.status === "ON" ? 'ON' : 'OFF'}</span>
                <span className="device-modal-switch-circle"></span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeviceNotificationSettingsModal;
